import { render } from "./SignIn.vue?vue&type=template&id=6ce24a52"
import script from "./SignIn.vue?vue&type=script&lang=ts"
export * from "./SignIn.vue?vue&type=script&lang=ts"
script.render = render

export default script